"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = void 0;
var tslib_1 = require("tslib");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var options_1 = require("./options");
var error_1 = require("./error");
var utils_1 = require("./utils");
var constants_1 = require("./constants");
var env_util_1 = require("./env-util");
var headers_1 = require("./headers");
var xhr_1 = (0, tslib_1.__importDefault)(require("axios/lib/adapters/xhr"));
var HttpClient = /** @class */ (function () {
    function HttpClient(opts) {
        if (opts === void 0) { opts = {}; }
        this.opts = opts;
        this.opts = defaultClientOptions(this.opts);
        this.client = axios_1.default.create(this.opts);
    }
    HttpClient.isHttpError = function (payload) {
        return !!(payload === null || payload === void 0 ? void 0 : payload.isWixHttpError);
    };
    HttpClient.prototype.request = function (requestOptionsOrFactory) {
        var _a, _b;
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var host, protocol, urlObject, requestOptions, signedInstance, options;
            var _this = this;
            return (0, tslib_1.__generator)(this, function (_c) {
                host = (0, utils_1.resolveHost)(this.opts);
                protocol = (0, utils_1.resolveProtocol)(this.opts);
                urlObject = { protocol: protocol, host: host };
                requestOptions = typeof requestOptionsOrFactory === 'function'
                    ? requestOptionsOrFactory({ isSSR: this.opts.isSSR, host: host })
                    : requestOptionsOrFactory;
                signedInstance = ((_b = (_a = this.opts).getAppToken) === null || _b === void 0 ? void 0 : _b.call(_a)) || '';
                options = (0, options_1.buildOptions)({
                    requestOptions: requestOptions,
                    urlObject: urlObject,
                    wixHeadersOpts: {
                        signedInstance: signedInstance,
                        artifactId: this.opts.artifactId,
                        csrf: false /* axios handles xsrf */,
                        multilingualOptions: this.opts.multilingualOptions,
                    },
                    globalConfig: (0, utils_1.getGlobalConfig)(),
                });
                if (this.opts.isSSR) {
                    options.baseURL = "".concat(constants_1.SSR_PROTOCOL, "://").concat(constants_1.SSR_HOST);
                }
                return [2 /*return*/, this.client
                        .request(options)
                        .catch(function (err) {
                        return _this.maybeFallbackRequest(err, requestOptions, urlObject, signedInstance);
                    })
                        .catch(function (err) { return _this.handleRequestError(err, options); })
                        .then(function (res) { return _this.transformResponse(res, requestOptions); })];
            });
        });
    };
    HttpClient.prototype.get = function (url, requestOptions) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var opts;
            return (0, tslib_1.__generator)(this, function (_a) {
                opts = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, requestOptions), { url: url, method: 'GET' });
                return [2 /*return*/, this.request(opts)];
            });
        });
    };
    HttpClient.prototype.delete = function (url, requestOptions) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var opts;
            return (0, tslib_1.__generator)(this, function (_a) {
                opts = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, requestOptions), { url: url, method: 'DELETE' });
                return [2 /*return*/, this.request(opts)];
            });
        });
    };
    HttpClient.prototype.head = function (url, requestOptions) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var opts;
            return (0, tslib_1.__generator)(this, function (_a) {
                opts = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, requestOptions), { url: url, method: 'HEAD' });
                return [2 /*return*/, this.request(opts)];
            });
        });
    };
    HttpClient.prototype.options = function (url, requestOptions) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var opts;
            return (0, tslib_1.__generator)(this, function (_a) {
                opts = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, requestOptions), { url: url, method: 'OPTIONS' });
                return [2 /*return*/, this.request(opts)];
            });
        });
    };
    HttpClient.prototype.post = function (url, data, requestOptions) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var opts;
            return (0, tslib_1.__generator)(this, function (_a) {
                opts = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, requestOptions), { url: url, data: data, method: 'POST' });
                return [2 /*return*/, this.request(opts)];
            });
        });
    };
    HttpClient.prototype.put = function (url, data, requestOptions) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var opts;
            return (0, tslib_1.__generator)(this, function (_a) {
                opts = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, requestOptions), { url: url, data: data, method: 'PUT' });
                return [2 /*return*/, this.request(opts)];
            });
        });
    };
    HttpClient.prototype.patch = function (url, data, requestOptions) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var opts;
            return (0, tslib_1.__generator)(this, function (_a) {
                opts = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, requestOptions), { url: url, data: data, method: 'PATCH' });
                return [2 /*return*/, this.request(opts)];
            });
        });
    };
    Object.defineProperty(HttpClient.prototype, "CancelToken", {
        get: function () {
            return axios_1.default.CancelToken;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpClient.prototype, "isCancel", {
        get: function () {
            return axios_1.default.isCancel;
        },
        enumerable: false,
        configurable: true
    });
    HttpClient.prototype.handleRequestError = function (error, requestOptions) {
        var requestError = new error_1.HttpError(error);
        (0, utils_1.silent)(function () { var _a; return (_a = requestOptions.onError) === null || _a === void 0 ? void 0 : _a.call(requestOptions, requestError); });
        throw requestError;
    };
    HttpClient.prototype.maybeFallbackRequest = function (err, requestOptions, urlObject, signedInstance) {
        var _a, _b, _c;
        var shouldFallbackRequest = (0, utils_1.isHttpMockServerEnabled)() &&
            (0, utils_1.shouldAllowUnmocked)() &&
            ((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 404 &&
            ((_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.msg) === constants_1.NO_SCENARIO_FOUND;
        if (shouldFallbackRequest) {
            var prodOptions = (0, options_1.buildOptions)({
                requestOptions: requestOptions,
                urlObject: urlObject,
                wixHeadersOpts: {
                    signedInstance: signedInstance,
                    artifactId: this.opts.artifactId,
                },
            });
            return this.client.request(prodOptions);
        }
        throw err;
    };
    HttpClient.prototype.transformResponse = function (res, requestOptions) {
        var requestId = (0, headers_1.requestIdOrEmptyString)(res);
        var data = transformData(res, requestOptions);
        return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, res), { data: data, requestId: requestId });
    };
    /** @deprecated Please use the instance method instead, eg, httpClient.CancelToken.source() */
    HttpClient.CancelToken = axios_1.default.CancelToken;
    /** @deprecated Please use the instance method instead, eg, httpClient.isCancel() */
    HttpClient.isCancel = axios_1.default.isCancel;
    return HttpClient;
}());
exports.HttpClient = HttpClient;
function defaultClientOptions(opts) {
    var adapter = opts.adapter;
    if (!adapter) {
        // Default - related to 2 cases: Bundled to Client  / Bundled to Viewer (SSR - isolated VM)
        adapter = xhr_1.default;
        // 2 cases: Bundled to server (SSR) & classic Node (Not bundled at all) (axios needs to be in the node_modules)
        if ((0, env_util_1.isNode)()) {
            adapter = getNodeAdapter();
        }
    }
    return (0, tslib_1.__assign)({ adapter: adapter, isSSR: false }, opts);
}
function getNodeAdapter() {
    // https://github.com/webpack/webpack/issues/5939#issue-272316127
    var requireFunc = typeof __webpack_require__ === 'function'
        ? __non_webpack_require__
        : require;
    return requireFunc('axios/lib/adapters/http');
}
function transformData(res, requestOptions) {
    var resData = res.data;
    if (requestOptions._pickResponseBody) {
        resData = (0, utils_1.extractProp)(res.data, requestOptions._pickResponseBody);
    }
    if (requestOptions._logs) {
        var logs = (0, utils_1.extractProp)(res.data, requestOptions._logs);
        if (logs === null || logs === void 0 ? void 0 : logs.length) {
            logs.map(function (log) { return console.log.apply(console, log); });
        }
    }
    return resData;
}
//# sourceMappingURL=http-client.js.map